import React from 'react';
import { useTable } from './useTable';
import { CustomTable } from 'src/components/CustomTable/CustomTable';

export const IssuerRequestsTable = () => {
  const { build } = useTable();

  return <CustomTable build={build} />;
};
